import { Typography } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import styles from './Filter.module.scss';
import { IFilterText } from './types';

const FilterText = (props: IFilterText) => {
  const { selectedFilters, disabled, titleClass, isSingleSelect, title } = props;
  return (
    <Typography
      variant="p3"
      className={cx(
        styles['filter--title'],
        {
          [styles['filter--title--active']]: selectedFilters.length > 0,
          [styles['filter--title--disabled']]: disabled
        },
        titleClass
      )}
    >
      {title} {!isSingleSelect && selectedFilters.length > 0 && `(${selectedFilters.length})`}
    </Typography>
  );
};

export default FilterText;
